module.exports = __webpack_public_path__ + "e02fbcec.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/static/hitsDefault.png
// module id = 1235
// module chunks = 1